var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.895 3.823c.281-.482.422-.723.618-.898.173-.155.377-.272.598-.344.25-.08.53-.08 1.087-.08h1.604c.558 0 .837 0 1.087.08.221.072.425.189.599.344.195.175.336.416.617.898l.395.677h.5c.934 0 1.4 0 1.757.182.313.16.568.415.728.728.182.357.182.823.182 1.757v4c0 .933 0 1.4-.182 1.757-.16.313-.415.568-.728.728-.357.182-.823.182-1.757.182H4c-.933 0-1.4 0-1.756-.182a1.667 1.667 0 0 1-.729-.728c-.181-.357-.181-.824-.181-1.757v-4c0-.934 0-1.4.181-1.757.16-.313.415-.568.729-.728C2.6 4.5 3.067 4.5 4 4.5h.5l.395-.677ZM8 11.867a3.167 3.167 0 1 0 0-6.333 3.167 3.167 0 0 0 0 6.333ZM9.8 8.7a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.ac09e9a5a47015d77c24db3cb070c9f3.svg";
export { ForwardRef as ReactComponent };